let xAxiosData = [
    {
        'name': 'Jan',
        'Sale': 112_000
    },
    {
        'name': 'Feb',
        'Sale': 99_000
    },
    {
        'name': 'Mar',
        'Sale': 12_090
    },
    {
        'name': 'Apr',
        'Sale': 99_000
    },
    {
        'name': 'MAy',
        'Sale': 54_000
    },
    {
        'name': 'Jun',
        'Sale': 200_000
    },
    {
        'name': 'Jul',
        'Sale': 34_000
    },
    {
        'name': 'Agu',
        'Sale': 80_000
    },
    {
        'name': 'Sept',
        'Sale': 180_000
    },
    {
        'name': 'Oct',
        'Sale': 58_510
    },
    {
        'name': 'Nov',
        'Sale': 11_900
    },
    {
        'name': 'Dev',
        'Sale': 98_000
    },
]


export const newMembers = [
    { id: 1, userName: 'Mohammad Amin', title: 'web developer', img: 'images/npm.png' },
    { id: 2, userName: 'Amin', title: 'back-end developer', img: 'images/npm.png' },
    { id: 3, userName: 'mohammad', title: 'front-end developer', img: 'images/npm.png' },
    { id: 4, userName: 'Ali', title: 'CEO', img: 'images/npm.png' },
    { id: 5, userName: 'Saman', title: 'web developer', img: 'images/npm.png' },
]



export default xAxiosData